import { EditView } from '@builtbypixel/nucleus';
import React from 'react';

import setup from './setup';
import DynamicFields from '../Products/Fields/DynamicFields';

const EditForm = () => {
  return (
    <EditView setup={setup} isFullWidth>
      <FieldComponent />
    </EditView>
  );
};

const FieldComponent = () => {
  return (
    <DynamicFields />
  );
};

export default EditForm;
